require('../../modules/es6.symbol');
module.exports = require('../../modules/_core').Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/library/fn/object/get-own-property-symbols.js
// module id = 1146
// module chunks = 168707334958949